import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';

import { messages as i18n } from '@teem/constants/messages';
import { HIDE_PAYMENT_DATE } from '@teem/constants/defaults';

@Component({
  selector: 'stcpay-tab',
  templateUrl: './stcpay-tab.component.html',
  styleUrls: ['./stcpay-tab.component.scss']
})
export class StcpayTabComponent implements OnInit {
  @Output() public updateUserDetails = new EventEmitter();
  @Output() public goToPlan = new EventEmitter();
  submitted: boolean = false;
  userDetails: any = null;
  labelStatus :string = 'default_show';
  dueDate:any = moment(HIDE_PAYMENT_DATE);
  nowDate:any = moment();

  merchantForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private userService: UserService,
    private sharedDataService: SharedDataService
  ) { }


  ngOnInit(): void {
    this.merchantForm = this.fb.group({
      merchant_name_en: [this.userDetails ? this.userDetails?.stcpay?.merchant_name_en : '', Validators.required],
      merchant_name_ar: [this.userDetails ? this.userDetails?.stcpay?.merchant_name_ar : '', Validators.required],
      merchant_id: [this.userDetails ? this.userDetails?.stcpay?.merchant_id : '', Validators.required],
      category: [this.userDetails ? this.userDetails?.stcpay?.category : '', Validators.required],
      merchant_url: [this.userDetails ? this.userDetails?.stcpay?.merchant_url : '', Validators.required],
      // merchant_id: [this.userDetails ? this.userDetails.stcpay_merchant_id : '', Validators.required],
    });
  }

  @Input('userDetails')
  set setUserDetails(val: any) {
    // console.log(val , this.merchantForm);
    if(val) {
      this.userDetails = val;

      if(this.merchantForm) {
        this.merchantForm.get('merchant_name_en').setValue(val?.stcpay?.merchant_name_en);
        this.merchantForm.get('merchant_name_ar').setValue(val?.stcpay?.merchant_name_ar);
        this.merchantForm.get('merchant_id').setValue(val?.stcpay?.merchant_id);
        this.merchantForm.get('category').setValue(val?.stcpay?.category);
        this.merchantForm.get('merchant_url').setValue(val?.stcpay?.merchant_url);
        // this.merchantForm.get('merchant_id').setValue(val.stcpay_merchant_id);
      }
    } else {
      if(this.merchantForm) {
        this.merchantForm.get('merchant_name_en').setValue('');
        this.merchantForm.get('merchant_name_ar').setValue('');
        this.merchantForm.get('merchant_id').setValue('');
        this.merchantForm.get('category').setValue('');
        this.merchantForm.get('merchant_url').setValue('');
        // this.merchantForm.get('merchant_id').setValue('');
      }
    }

    if (this.userDetails?.subscription.subscription_status == 'free') {
      this.labelStatus = 'free_user';
    } else {
      this.labelStatus = 'paid_user';
    }
    
  }

  get f() {
    return this.merchantForm.controls;
  }

  onSubmit(form: FormGroup) {
    this.submitted = true;
    if (form.valid) {
      this.loaderService.startLoading();
      this.userService.addMerchantInfo('stc-pay', form.value).subscribe(
        (res: any) => {
          this.loaderService.stopLoading();

          // Update parent user
          this.userDetails = res.user;
          this.userDetails.stcpay_merchant_id = res.user.stcpay_merchant_id;
          this.userDetails.accept_stcpay_payment = res.user.accept_stcpay_payment;
          this.updateUserDetails.emit(this.userDetails);

          // Update app basic info for user
          let userInfo = this.sharedDataService.getItem('userInfo');
          if (userInfo != undefined) {
            userInfo = res.user;
            userInfo.stcpay_merchant_id = res.user.stcpay_merchant_id;
            userInfo.accept_stcpay_payment = res.user.accept_stcpay_payment;
            this.sharedDataService.setItem('userInfo', userInfo);
          }

          Swal.fire(i18n.done, i18n.setting.stcpay_merchant_added, 'success');
        },
        (err) => {
          this.loaderService.stopLoading();
          if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.merchantForm.get(prop)?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          }
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        }
      )

    }
  }

  deleteMerchant() {
    this.submitted = false;
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.setting.remove_stcpay_merchant_confirm,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then( (result:any) => {
      if (result.value) {
        this.loaderService.startLoading();
        this.userService.removeSTCMerchant('stc-pay').subscribe((data: any) => {
          this.loaderService.stopLoading();
          this.userDetails = data.user;
          
          this.merchantForm.reset();
          this.merchantForm.get('merchant_id').setValue('');

          // Update parent user
          this.userDetails.stcpay_merchant_id = null;
          this.userDetails.accept_stcpay_payment = 0;
          this.updateUserDetails.emit(this.userDetails);

          // Update app basic info for user
          let userInfo = this.sharedDataService.getItem('userInfo');
          if (userInfo != undefined) {
            userInfo = data.user;
            userInfo.stcpay_merchant_id = null;
            userInfo.accept_stcpay_payment = 0;
            this.sharedDataService.setItem('userInfo', userInfo);
          }

          setTimeout(function () {
            Swal.fire(i18n.done, i18n.setting.remove_stcpay_merchant_success, 'success');
          }, 0);
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      } else {
        return false;
      }
    });

  }


}
